import { atom } from "recoil";

// Firebaseのデータが更新されるトリガーの役割
export const singleOrCumsumState = atom<boolean>({
  key: "singleOrCumsumState",
  default: true,
});
